import { TASK_TYPES } from 'features/daily-plan/constants';
import { EntityRoutes } from 'routes/constants';
import { ContactIncludes } from 'services/includes';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { ContactEntity, ContactRole, ENTITY_TYPE_ID_MAP, TabKeys } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const CONTACT_DRAWERS = {
  Edit: 'edit',
  Task: 'task'
};

export const CONTACT_QUERY_PARAMS = {
  ContactId: 'contactId'
};

export const ALLOWED_TASKS_BY_CONTACT_ROLE = {
  [ContactRole.Candidate]: [TASK_TYPES.other, TASK_TYPES.recruitJobOrder],
  [ContactRole.HiringAuthority]: [TASK_TYPES.other, TASK_TYPES.marketCandidate],
  [ContactRole.Name]: [TASK_TYPES.other]
};

export const CONTACT_TAB_IDS = {
  Overview: TabKeys.Overview,
  ActionPlan: TabKeys.Tasks,
  DataSheet: TabKeys.DataSheet
};

export const CONTACT_PROFILE_CONFIG = {
  endpoint: Endpoints.Names,
  entityTypeId: ENTITY_TYPE_ID_MAP.name,
  id: ContactEntity.id,
  includes: () => [ContactIncludes],
  requestAssignmentLabel: strings.inventoryProfiles.common.startRecruiting,
  route: id => EntityRoutes.ContactProfile.replace(':id', id),
  sectionName: ContactEntity.title,
  tabsStorageKey: PERSISTENCE_KEYS.PROFILE_TABS.CONTACTS,
  tabsSubheader: `${ContactEntity.singular} ${strings.inventoryProfiles.title}`,
  title: ContactEntity.title,
  trackingUrl: Endpoints.NameRecentlyViewed,
  type: 'contact'
};
